import {
  Input,
  Output,
  Component,
  EventEmitter,
} from '@angular/core';

import { ThemePalette } from '@angular/material/core/common-behaviors/color';

import { ButtonBehaviourTypesEnum, ButtonTypesEnum } from '../../enums';

@Component({
  selector: 'app-async-button',
  templateUrl: './async-button.component.html',
  styleUrls: ['./async-button.component.scss'],
})
export class AsyncButtonComponent {
  public buttonTypesEnum: typeof ButtonTypesEnum;

  @Input() public type: number;
  @Input() public content: string;
  @Input() public disabled: boolean;
  @Input() public color: ThemePalette;
  @Input() public isRequestMade: boolean;
  @Input() public class: string | undefined;
  @Input() public buttonBehaviourType: ButtonBehaviourTypesEnum;

  @Output() public buttonClicked: EventEmitter<boolean>;

  constructor() {
    this.content = '';
    this.disabled = false;
    this.isRequestMade = false;
    this.type = ButtonTypesEnum.Flat;
    this.buttonTypesEnum = ButtonTypesEnum;
    this.buttonBehaviourType = ButtonBehaviourTypesEnum.Button;
    this.buttonClicked = new EventEmitter();
  }

  onButtonClick(): void {
    this.buttonClicked.emit(true);
  }
}
